
import React from 'react';
import { Task } from '@/types/lead';
import PendingTasksList from '../../business/tasks/PendingTasksList';
import CompletedTasksList from '../../business/tasks/CompletedTasksList';
import { useTaskDisplay } from './useTaskDisplay';

interface TaskListProps {
  pendingTasks: Task[];
  completedTasks: Task[];
  onCompleteTask: (taskId: string) => void;
  onDeleteTask: (taskId: string) => void;
  onUpdateTask: (taskId: string, updates: Partial<Task>) => void;
}

const TaskList: React.FC<TaskListProps> = ({
  pendingTasks,
  completedTasks,
  onCompleteTask,
  onDeleteTask,
  onUpdateTask,
}) => {
  const {
    renderAssignee,
    formatDueDate,
    getPriorityBadge,
    getTaskStatusIndicator,
  } = useTaskDisplay();

  return (
    <div className="space-y-6">
      {pendingTasks.length > 0 && (
        <PendingTasksList
          tasks={pendingTasks}
          onCompleteTask={onCompleteTask}
          onDeleteTask={onDeleteTask}
          onUpdateTask={onUpdateTask}
          renderAssignee={renderAssignee}
          formatDueDate={formatDueDate}
          getPriorityBadge={getPriorityBadge}
          getTaskStatusIndicator={getTaskStatusIndicator}
        />
      )}

      {completedTasks.length > 0 && (
        <CompletedTasksList
          tasks={completedTasks}
          onDeleteTask={onDeleteTask}
          getTaskStatusIndicator={getTaskStatusIndicator}
        />
      )}
    </div>
  );
};

export default TaskList;
